import { toast } from "react-hot-toast";

export function handleApiError(error) {
  if (!error?.response) {
    toast.error("Something went wrong.");
    return;
  }

  const data = error.response.data;

  // Case 1: { "error": "Something went wrong" }
  if (typeof data?.error === "string") {
    toast.error(data.error);
    return;
  }

  const messages = [];

  // Case 2: { "errors": { "field": ["message"] } }
  if (typeof data?.errors === "object" && !Array.isArray(data.errors)) {
    for (const key in data.errors) {
      const value = data.errors[key];
      if (Array.isArray(value)) {
        value.forEach((msg) => messages.push(`${capitalize(key)}: ${msg}`));
      } else if (typeof value === "string") {
        messages.push(`${capitalize(key)}: ${value}`);
      }
    }
  }

  // Case 3: Field-level errors directly in data
  else if (typeof data === "object" && !Array.isArray(data)) {
    for (const key in data) {
      const value = data[key];
      if (Array.isArray(value)) {
        value.forEach((msg) => messages.push(`${capitalize(key)}: ${msg}`));
      } else if (typeof value === "string") {
        messages.push(`${capitalize(key)}: ${value}`);
      }
    }
  }

  if (messages.length > 0) {
    toast.error(
      <div style={{ whiteSpace: "pre-line" }}>{messages.join("\n")}</div>
    );
    return;
  }

  // Fallback
  toast.error("An unexpected error occurred.");
}

function capitalize(word) {
  return word?.charAt(0).toUpperCase() + word?.slice(1);
}
